import { render } from "./AccountMiddleProduct.vue?vue&type=template&id=4edba7ee&scoped=true"
import script from "./AccountMiddleProduct.vue?vue&type=script&steup=true&lang=js"
export * from "./AccountMiddleProduct.vue?vue&type=script&steup=true&lang=js"

import "./AccountMiddleProduct.vue?vue&type=style&index=0&id=4edba7ee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edba7ee"]])

export default __exports__